export const GET_CONFIRMED_STATEMENT = "GET_CONFIRMED_STATEMENT"
export const GET_CONFIRMED_STATEMENT_SUCCESS = "GET_CONFIRMED_STATEMENT_SUCCESS"

export const GET_PENDING_STATEMENT = "GET_PENDING_STATEMENT"
export const GET_PENDING_STATEMENT_SUCCESS = "GET_PENDING_STATEMENT_SUCCESS"